// Quiet env badge for the tenant portal footer.
// Bordered + muted text, NOT the prominent admin treatment — consumers
// shouldn't be confused by a screaming "STAGING" pill.

import type { CSSProperties } from 'react';
import styles from './EnvBadge.module.css';

export type EnvLabel = 'prod' | 'staging' | 'dev';

export interface EnvBadgeProps {
  env: EnvLabel;
  /** Override the label text (e.g. localized "EU · v0.5" suffix). */
  trailing?: string;
}

export function EnvBadge({ env, trailing }: EnvBadgeProps) {
  if (env === 'prod') {
    // Prod is the un-alarming default — render only the trailing meta, no pill.
    return trailing ? <span className={styles.trailing}>{trailing}</span> : null;
  }
  const label = env === 'staging' ? 'STAGING' : 'DEV';
  const style: CSSProperties = env === 'staging' ? {} : { ['--badge-tint' as string]: '#3F6FB8' };
  return (
    <span className={styles.wrapper}>
      <span className={styles.pill} style={style}>{label}</span>
      {trailing && <span className={styles.trailing}>{trailing}</span>}
    </span>
  );
}
